"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const lock = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-lock` : '') + (description ? ` desc-lock` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-lock"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-lock"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 0C15.2384 0 17.8776 2.56557 17.9959 5.77506L18 6V9H18.75C19.9409 9 20.9156 9.92516 20.9948 11.096L21 11.25V21.75C21 22.9926 19.9926 24 18.75 24H5.25C4.00736 24 3 22.9926 3 21.75V11.25C3 10.0074 4.00736 9 5.25 9H6V6C6 2.68629 8.68629 0 12 0ZM18.75 10.5H5.25C4.83579 10.5 4.5 10.8358 4.5 11.25V21.75C4.5 22.1642 4.83579 22.5 5.25 22.5H18.75C19.1642 22.5 19.5 22.1642 19.5 21.75V11.25C19.5 10.8358 19.1642 10.5 18.75 10.5ZM12 14.25C12.3797 14.25 12.6935 14.5322 12.7432 14.8982L12.75 15V18C12.75 18.4142 12.4142 18.75 12 18.75C11.6203 18.75 11.3065 18.4678 11.2568 18.1018L11.25 18V15C11.25 14.5858 11.5858 14.25 12 14.25ZM12 1.5C9.58573 1.5 7.61551 3.40124 7.5049 5.78816L7.5 6V9H16.5V6C16.5 3.51472 14.4853 1.5 12 1.5Z",
    fill: "inherit"
  }));
};
var _default = exports.default = lock;